import { css } from 'lit';

export default css`
    .content {
        border-radius: var(--metrics-radius-s);
        overflow: hidden;
    }

    .content .header {
        border-radius: var(--metrics-radius-s) var(--metrics-radius-s) 0 0;
        height: var(--size-px--48px);
        background: var(--color-surface-secondary-blur);
    }

    .content .header button,
    .content .header vaadin-button {
        padding: var(--metrics-spacing-xs) var(--metrics-spacing-s);
    }

    .content .header h1 {
        margin-right: auto;
        margin-left: var(--metrics-spacing-m);
        font-size: var(--font-size-body-l);
        font-weight: var(--font-weight-body-m);
    }

    ki-portal-base-timerange-selector
        .timerangeSelector
        vaadin-text-field#dateFrom::part(clear-button) {
        display: none;
    }

    #graphwrapper ki-ds-graph {
        width: 100%;
    }

    @media (hover: none) {
        .content .header ki-portal-base-timerange-selector .timerangeSelector .timeSelector {
            right: 0;
            top: 0;
            box-shadow: none;
            bottom: 0;
            width: 100%;
            height: 100%;
            left: 0;
        }
    }

    @media (max-width: 768px) {
        .content .header {
            justify-content: center;
            height: auto;
            padding: var(--metrics-spacing-s);
        }

        .content .header h1 {
            display: none;
        }

        .content .header ki-portal-base-timerange-selector {
            margin-right: 0;
        }
    }
`;
